import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SharedService } from '../shared/shared.service';
import { Router } from '@angular/router';
import { UsefulToolsService } from '../shared/other/usefultools.service';
import { UsersService } from '../home/content-area/system-setup/users.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.html',
  styleUrls: ['./login.scss']
})
export class LoginComponent implements OnInit {
  password = '';
  user = '';
  session = '';

  constructor(
    private httpclient: HttpClient,
    public sharedservice: SharedService,
    private router: Router,
    private usefultoolsservice: UsefulToolsService
  ) { }

  ngOnInit() {
  }

  Logon() {
    const logonObj = {
        UserID: this.user,
        Password: this.password
      };

    this.httpclient.post<any>(`${this.sharedservice.URL}/utLogon`, logonObj).subscribe(
      response => {
        console.log(response.utLogon_response);
        if(response.utLogon_response.SessionID != undefined){
          sessionStorage.setItem('com-session-id', response.utLogon_response.SessionID);
          // this.router.navigate(['/home/dashboard']);
          const postSession = {
            SessionID: response.utLogon_response.SessionID,
            ID: this.user
          };
          this.httpclient.post<any>(`${this.sharedservice.URLnode}/utUserID`, postSession).subscribe(Response => {
            console.log(Response);
            this.sharedservice.UserLevel = Response.recordset == null ? [] : Response.recordset[0];
          });
          this.router.navigate(['/home/trips']);
        } else {
          this.usefultoolsservice.notify('error', 'Invalid login');
        }
      });
  }

}
